<script setup>
import SectionViewer from '../../components/SectionViewer.vue'

// Define subsections
const sections = [
  { id: 'mision-vision', title: '1.1 Misión, visión, funciones y deberes' },
  { id: 'estructura-organica', title: '1.2 Estructura orgánica - Organigrama' },
  { id: 'mapas-procesos', title: '1.3 Mapas y Cartas descriptivas de los procesos' },
  { id: 'directorio-institucional', title: '1.4 Directorio Institucional' },
  { id: 'directorio-servidores', title: '1.5 Directorio de servidores públicos' },
  { id: 'directorio-entidades', title: '1.6 Directorio de entidades' },
  { id: 'directorio-agremiaciones', title: '1.7 Directorio de agremiaciones' },
  { id: 'procedimientos-decisiones', title: '1.9 Procedimientos para tomar decisiones' },
  { id: 'mecanismo-solicitudes', title: '1.10 Mecanismo de presentación de solicitudes' },
  { id: 'calendario-actividades', title: '1.11 Calendario de actividades y eventos' },
  { id: 'decisiones-publico', title: '1.12 Información sobre decisiones' },
  { id: 'entes-vigilancia', title: '1.13 Entes y autoridades que lo vigilan' },
  { id: 'hojas-vida', title: '1.14 Publicación de hojas de vida' }
]
</script>

<template>
  <SectionViewer :sections="sections" title="1. Información de la Entidad" />
</template>
